import type { JSX } from 'react'

import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { AppTitle } from '~/shared/ui/components/AppTitle'

export function Title(): JSX.Element {
  return <AppTitle t='credits_title' />
}

const skin = era.skin('routes/settings/data-sources')

DataSourcesSubPage.displayName = 'DataSourcesSubPage'
export function DataSourcesSubPage(): JSX.Element {
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper>
        <ui.RenderSkin name='dataSourcesSubPageSkin' />
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
